import { useCallback, useContext, useState } from 'react';

import { RightContext } from '@/components/RightProvider/context';
import { viralTemplateModal } from '@/components/UIComponents/CommonModal';
import { fetchViralTemplateForm } from '@/services/viralTemplate';
import { EventNewID, ViralTemplateExposeFromEnum } from '@/utils/eventlog/eventNewConfig';
import { trackEvent } from '@/utils/eventlog/logAdapter';

import type { TplTemplateVO } from '../_components/template-ui/types';
import { toTemplateDetailVO } from '../utils/templateForm';
import { resolveViralTemplateCreditCost } from '../utils/templatePricing';

/**
 * 打开爆款模板表单弹窗（仅应在点击「复刻」等明确入口时调用）。
 */
export function useViralTemplateFormModal(from: ViralTemplateExposeFromEnum) {
  const [loadingDetail, setLoadingDetail] = useState(false);
  const rightContext = useContext(RightContext);

  const openFormModal = useCallback(
    async (tpl: TplTemplateVO) => {
      await rightContext.getUserLoginState({
        onReady: async () => {
          setLoadingDetail(true);
          try {
            const id = tpl.id;
            const res = id ? await fetchViralTemplateForm({ id }) : null;
            const detail = toTemplateDetailVO(tpl, res?.data);
            const credit = resolveViralTemplateCreditCost(tpl);
            trackEvent(EventNewID.VITAL_TEMPLATE_MODAL_EXPOSE, {
              template_id: id,
              from,
            });
            void viralTemplateModal.show({ detail, creditCost: credit });
          } finally {
            setLoadingDetail(false);
          }
        },
      });
    },
    [from, rightContext],
  );

  return { openFormModal, loadingDetail };
}
